// extracted by mini-css-extract-plugin
module.exports = {"container":"nowplaying_container__2jXnP","imgContainer":"nowplaying_imgContainer__29FLa","btnReturn":"nowplaying_btnReturn__35Je2"};